import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import ConditionEditor from './ConditionEditor';

const FormConditionEditor = ({
  forms,
  selectedForm,
  onSaveCondition,
  onRemoveCondition
}) => {
  const [localCondition, setLocalCondition] = useState({ logic: 'AND', groups: [] });

  useEffect(() => {
    setLocalCondition(selectedForm.condition || { logic: 'AND', groups: [] });
  }, [selectedForm]);

  const allFields = forms
    .flatMap(f => f.fields.map(field => ({ ...field, formName: f.name })));

  return (
    <>
      <h6 className="mt-4">Form Condition (Optional)</h6>

      <ConditionEditor
        value={localCondition}
        onChange={setLocalCondition}
        allFields={allFields.map(field => ({
          ...field,
          label: `${field.formName} - ${field.label}`
        }))}
      />
      <br/>
      <Button className="mt-3" onClick={() => {
        onSaveCondition(localCondition)
      }}>
        Save Form Condition
      </Button>

      {selectedForm.condition && (
        <Button
          variant="outline-danger"
          className="mt-3"
          onClick={onRemoveCondition}
        >
          ❌ Remove Condition
        </Button>
      )}
    </>
  );
};

export default FormConditionEditor;
